import { useQuery } from "react-query";
import { getAppointmentChecklists } from "../api/getAppointmentChecklists";

export const useAppointmentChecklists = (appointmentId: number) => {
  return useQuery(["appointment-checklists", appointmentId], () =>
    getAppointmentChecklists(appointmentId)
  );
};
